// extracted by mini-css-extract-plugin
module.exports = {"author":"b1_kc","author__avatar":"b1_kd","author__img":"b1_kf","author__text":"b1_kg"};